import React from 'react';
import { IMG_BASE_PATH } from 'utils/constants';
import Media from '../media';

const Loader = () => {
  return (
    <>
      <div className='si-loader__wrap'>
        <div className='si-loader__spinner'></div>
        <div className='si-loader--img'>
          <Media imgSrc={`${IMG_BASE_PATH}images/loader-icc.png`} imgAlt='loader' />
        </div>
      </div>
    </>
  );
};

export default Loader;
